import React from 'react';
import Card from '../../../../components/Card/Card';
import { FormattedMessage } from 'react-intl';
import PostbackLogs from './PostbackLogs';
import Pagination from '../../../../components/Pagination/Pagination';
import { streams } from '../../../../services/ApiService';
import { Button, Modal, ModalBody, ModalHeader, Col, Row } from 'reactstrap';
import { LocalStorage } from '../../../../utils/utils';
import Icon from '../../../../components/Icon/Icon';
import LogsTableSettings from './LogsTableSettings';
import { ThemedFMessage } from '../../../../hoc/IntlComponents';


export default class PostbackLogsTable extends React.Component {
    state = {
        loading: false,
        streamId: null,
        logs: [],
        count: 0,
        page: 0,
        limit: 25,
        error: '',
        logsSettingsModalOpen: false,
        settings: {}
    };

    componentDidMount() {
        const { match } = this.props;

        if (match.params && match.params.id) {
            const streamId = parseInt(match.params.id, 10);

            if (!isNaN(streamId) && streamId > 0) {
                this.setState(
                    () => ({
                        loading: true,
                        streamId,
                    }),
                    () => {
                        const { limit, page } = this.state;
                        this.getPostbackLogs(limit, page);
                    },
                );
            } else if (match.params.id === 'logs') {
                this.setState(
                    () => ({
                        loading: true,
                    }),
                    () => {
                        const { limit, page } = this.state;
                        this.getGlobalPostbackLogs(limit, page);
                    },
                );
            }
        }

        const settings = LocalStorage.get('logsTableSettings');
        this.setState({ settings: settings ? settings : { hash: true, date: true, url: true, status: false, sended: true, received: true, leadID: true, method: true } });
    }

    /**
     * Get postback's logs by flow id
     *
     * @param {number} limit
     * @param {number} page
     * @return {Promise} Request result
     */
    getPostbackLogs = (limit, page) => {
        const { streamId } = this.state;

        return streams
            .getPostbackLogs(streamId, { limit, page })
            .then(({ items: logs, count }) => {
                this.setState(() => ({
                    loading: false,
                    logs,
                    count,
                }));
            })
            .catch(({ response = {} }) => this.handleError(response));
    };

    /**
     * Get global postback's logs
     *
     * @param {number} limit
     * @param {number} page
     * @return {Promise} Request result
     */
    getGlobalPostbackLogs = (limit, page) =>
        streams
            .getGlobalPostbackLogs({ limit, page })
            .then(({ items: logs, count }) => {
                this.setState(() => ({
                    loading: false,
                    logs,
                    count,
                }));
            })
            .catch(({ response = {} }) => this.handleError(response));

    handlePageChange = page => {
        this.setState(() => ({ loading: true }));

        this.getPostbackLogs(this.state.limit, page).then(() => this.setState({ page }));
    };

    handleError = response => {
        if (response.data && response.data.error) {
            const { message: error } = response.data.error;

            this.setState(() => ({
                loading: false,
                error: error.message,
            }));
        }
    };

    // handleSaveSettings = (settings) => {
    //     LocalStorage.set('logs', settings);
    // }

    saveSettings = (settings) => {
        LocalStorage.set('logsTableSettings', settings)
        this.setState(() => ({ settings }))
    }

    toggleLogsSettingsModal = () => this.setState(prevState => ({ logsSettingsModalOpen: !prevState.logsSettingsModalOpen }))

    render() {
        const { loading, limit, logs, count, page, error, logsSettingsModalOpen, settings } = this.state;
        const pageCount = Math.ceil(count / limit);
        return (
            <Card loading={loading}>
                <Card.Header>
                    <ThemedFMessage id="postback.logs.title" />
                    <Button color="primary" size="sm" style={{ float: "right" }} onClick={this.toggleLogsSettingsModal}>
                        <Icon type='kma-panel' tag='i' />
                    </Button>
                </Card.Header>
                <Card.Body className="no-padding">
                    <PostbackLogs settings={settings} logs={logs} error={error} />
                </Card.Body>
                <Card.Footer>
                    <Row>
                        <Col lg="10">
                            {pageCount > 1 && (

                                <Pagination
                                    activePage={page + 1}
                                    pageCount={pageCount}
                                    onPageChange={this.handlePageChange}
                                />

                            )}
                        </Col>
                        <Col lg='2'>
                            <Button color="primary" size="sm" style={{ float: "right" }} onClick={this.toggleLogsSettingsModal}>
                                <Icon type='kma-panel' tag='i' />
                            </Button>
                        </Col>
                    </Row>
                </Card.Footer>
                <Modal
                    className="modal-logs-settings"
                    isOpen={logsSettingsModalOpen}
                    toggle={this.toggleLogsSettingsModal}
                    size="lg"
                >
                    <ModalHeader>
                        <FormattedMessage id="postback.logs.settings" defaultMessage='Customize fields' />
                        <Button onClick={this.toggleLogsSettingsModal} close style={{ float: "right" }} />
                    </ModalHeader>
                    <ModalBody>
                        <LogsTableSettings toggleLogsSettingsModal={this.toggleLogsSettingsModal} settings={settings} saveSettings={this.saveSettings} />
                    </ModalBody>
                </Modal>
            </Card >
        )
    }
}